module.exports = __webpack_public_path__ + "img/alba-speciaux.020d005e.jpg";